<p-toast
  [key]="toastKey"
  [position]="position"
  styleClass="figma-alert-toast-host"
  (onClose)="onToastClose($event)"
>
  <ng-template let-message #headless let-closeFn="closeFn">
    <div
      class="figma-alert-toast-shell"
      [ngClass]="shellClass(message.severity)"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="figma-alert-toast-card">
        <div class="figma-alert-toast-icon-wrap" [ngClass]="iconWrapClass(message.severity)">
          @switch (message.severity) {
            @case ('success') {
              <svg class="figma-alert-toast-icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10" fill="#12B76A" />
                <path d="M8.5 12.2L10.8 14.5L15.8 9.2" stroke="#FFFFFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            }
            @case ('warn') {
              <svg class="figma-alert-toast-icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10" fill="#DEC029" />
                <path d="M12 7.5V13" stroke="#FFFFFF" stroke-width="1.8" stroke-linecap="round" />
                <circle cx="12" cy="16.2" r="1.1" fill="#FFFFFF" />
              </svg>
            }
            @default {
              <svg class="figma-alert-toast-icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10" fill="#F04438" />
                <path d="M9 9L15 15M15 9L9 15" stroke="#FFFFFF" stroke-width="1.8" stroke-linecap="round" />
              </svg>
            }
          }
        </div>

        <div class="figma-alert-toast-body">
          <div class="figma-alert-toast-head">
            <span class="figma-alert-toast-title" [ngClass]="titleClass(message.severity)">
              {{ displaySummary(message.summary) }}
            </span>
            <button
              type="button"
              class="figma-alert-toast-close"
              aria-label="Close"
              (click)="closeFn($event)"
            >
              <span class="figma-alert-toast-close-icon" aria-hidden="true"></span>
            </button>
          </div>
          @if (message.detail) {
            <p class="figma-alert-toast-detail">{{ message.detail }}</p>
          }
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
